import 'url-search-params-polyfill';
import { GlobalStyles } from '@bigcommerce/big-design';
import { theme } from '@bigcommerce/big-design-theme';
import React from 'react';
import { render } from 'react-dom';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { App } from './App';
import store from './store';
import { Provider } from 'react-redux';

const AppGlobalStyles = createGlobalStyle`
    body {
        height: 100%;
        max-width: 1080px;
        margin: 2rem auto;
        background-color: ${({ theme }) => theme.colors.secondary10};
    }
    img {
        max-width: 100%;
    }
    .app-panel-loading {
        position: relative;

        :after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(255,255,255,.8);
        }
    }
    .app-loading-indicator {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 20;
    }
    .paypal-buttons.paypal-buttons-layout-horizontal {
        vertical-align: middle;
    }
`;

render(
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <>
                <AppGlobalStyles />
                <GlobalStyles />
                <App />
            </>
        </ThemeProvider>
    </Provider>,
document.getElementById('root'),
);
